module.exports = __webpack_public_path__ + "img/step3.7c9e8c21.svg";